export const getDefaultState = () => {
  return {
    attributesList: null
  };
};

// initial state
const state = getDefaultState();

const getters = {
  getAllItemsAttributes(state, getters) {
    const items = getters.getAllItems;
    const attributesList = {};

    items.forEach((item) => {
      if (item && item.itemAttributes && item.itemAttributes.length) {
        item.itemAttributes.forEach((attribute) => {
          attributesList[attribute.id] = Object.assign({}, attribute, {
            selected: false
          });
        });
      }
    });

    return attributesList;
  },
  getSelectedAttributes(state) {
    return Object.values(state.attributesList).filter((attribute) => attribute.selected);
  },
  getUpdatedAttributeList(state) {
    return state.attributesList;
  },
  getOrderAgainItems(state, getters, rootState, rootGetters) {
    return (items) => {
      return items.filter((orderAgainItem) =>
        rootGetters["vendor/getAllItems"].some((menuItem) => menuItem.id === orderAgainItem.id)
      );
    };
  },
  getFilterEnabled(state) {
    if (!state.attributesList) return false;
    return Object.keys(state.attributesList).some((id) => state.attributesList[id].selected);
  },
  getShowHideStatus(state, getter) {
    return (item) => {
      // if no attribute is set true it will show all of the item.
      if (!getter.getFilterEnabled) return true;

      // if item doesn't have attributes but they are enabled it will hide the item.
      if (!item.itemAttributes || !item.itemAttributes.length) return false;

      const selected = getter.getSelectedAttributes;
      return selected.every((attribute) => {
        return item.itemAttributes.some((itemAttribute) => attribute.id === itemAttribute.id);
      });
    };
  }
};

// actions
const actions = {
  setAllItemsAttributes({ commit, getters }) {
    commit("updateAttributeList", getters.getAllItemsAttributes);
  },
  filterItemsByAttribute({ commit }, attribute) {
    commit("updateAttribute", attribute);
  },
  clearFilterAttributes({ commit, state }) {
    const clearedList = Object.assign({}, state.attributesList);
    Object.keys(clearedList).forEach((key) => (clearedList[key].selected = false));
    commit("updateAttributeList", clearedList);
  }
};

// mutations
const mutations = {
  updateAttributeList(state, newAttributeList) {
    state.attributesList = newAttributeList;
  },
  updateAttribute(state, id) {
    if (state.attributesList[id] !== undefined && state.attributesList[id] !== null) {
      state.attributesList[id].selected = !state.attributesList[id].selected;
    }
  },
  resetMenuItemsFilterState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
